import { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { useLocation } from 'react-router-dom';
import { status as getMaintenanceStatus } from '../../redux/api';
import { formatClockTime } from '../../maintenanceFormat';

const POLL_MS = 60 * 1000;

const reasonText = (status) =>
  status?.reason ? ` Reason: ${status.reason}.` : '';

// Notice above the sign-in form. The form itself stays usable during maintenance
// because admins must still be able to sign in; the backend turns everyone else away.
const MaintenanceLoginNotice = () => {
  const location = useLocation();
  const loggedOutForMaintenance =
    new URLSearchParams(location.search).get('reason') === 'maintenance';
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let active = true;
    const load = () =>
      getMaintenanceStatus()
        .then((res) => {
          if (active && res?.success && res?.data) setStatus(res.data);
        })
        .catch(() => null);
    load();
    const poll = setInterval(load, POLL_MS);
    return () => {
      active = false;
      clearInterval(poll);
    };
  }, []);

  let alert = null;
  if (status?.active && status.cutoff_passed) {
    alert = {
      type: 'error',
      message: loggedOutForMaintenance
        ? 'You were logged out for scheduled maintenance'
        : 'Nucleus is under maintenance',
      description: `Sign-in is unavailable while the system is being updated (since ${formatClockTime(
        status.logout_at
      )}).${reasonText(
        status
      )} Nucleus will be available again once maintenance is complete.`
    };
  } else if (status?.active) {
    alert = {
      type: 'warning',
      message: `Scheduled maintenance at ${formatClockTime(status.logout_at)}`,
      description: `You can sign in, but you will be logged out at ${formatClockTime(
        status.logout_at
      )}.${reasonText(status)}`
    };
  } else if (loggedOutForMaintenance && status) {
    alert = {
      type: 'success',
      message: 'Maintenance is complete',
      description: 'You can sign in now.'
    };
  } else if (loggedOutForMaintenance) {
    alert = {
      type: 'error',
      message: 'You were logged out for scheduled maintenance',
      description:
        'Nucleus will be available again once maintenance is complete.'
    };
  }

  if (!alert) return null;

  return <Alert className="mt-4" showIcon {...alert} />;
};

export default MaintenanceLoginNotice;
